var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('h1',{directives:[{name:"show",rawName:"v-show",value:(_vm.showCloseMsg),expression:"showCloseMsg"}],staticStyle:{"text-align":"center"}},[_vm._v("請關閉此頁面後，重新掃瞄QRcode")])])}
var staticRenderFns = []

export { render, staticRenderFns }